import { IPriceModel, IRecurringPriceModelModel } from "./store-price-model-data";
import { IDigitalContentModel } from "./store-product-content-data";

export interface IProductModel {
    type: ProductTypeModel;
    id: string;
    storeId: string;
    name: string;
    description?: string;
    sku?: string;
    priceModel: IPriceModel;
    isHidden?: boolean | null;
    imageRef?: IFileAttachmentRefModel;
    instructions?: string;
}

export interface IDigitalProductModel extends IProductModel {
    keyFeatures: string[];
    canUseAnnualPriceModel?: boolean;
    annualPriceModel?: IRecurringPriceModelModel;
}

export interface IFileAttachmentRefModel {
    id: string;
    displayUri?: string;
}

export enum ProductTypeModel {
    Digital = "Digital"
}
